<template>
  <section class="selftests">

      <div class="tab">
        <span
            v-if="this.$store.getters.getPermissions?.viewDeviceSelftestResults === true"
            class="tab_title"
            :class="{ active : block==='SelfTestList'}"
            @click="selected_block('SelfTestList')"
        >
          {{this.translate('selftest_list')}}
        </span>

        <span
            v-if="this.$store.getters.getPermissions?.viewDeviceSnapshot === true"
            class="tab_title"
            :class="{ active : block==='SnapshotsList'}"
            @click="selected_block('SnapshotsList')"
        >
          {{this.translate('snapshot.list')}}
        </span>

        <span
            v-if="this.$store.getters.getPermissions?.viewDeviceFactoryTest === true"
            class="tab_title"
            :class="{ active : block==='FactoryTestList'}"
            @click="selected_block('FactoryTestList')"
        >
          {{this.translate('factorytest_list')}}
        </span>
      </div>
      <div class="block">
        <SelfTestsList
            v-if="block==='SelfTestList' && this.$store.getters.getPermissions?.viewDeviceSelftestResults === true"
            :device_id="this.profile.id"
        />
        <SnapshotsList
            v-if="block==='SnapshotsList' && this.$store.getters.getPermissions?.viewDeviceSnapshot === true"
            :profile="profile"
        />
        <FactoryTestList
            v-if="block==='FactoryTestList' && this.$store.getters.getPermissions?.viewDeviceFactoryTest === true"
            :device_id="this.profile.id"
        />
      </div>

  </section>
</template>

<script>
import SelfTestsList from "./SelfTest/SelfTestsList"
import FactoryTestList from "./SelfTest/FactoryTestList"
import SnapshotsList from "./SelfTest/SnapshotsList"

export default {
  name: 'SelfTests',
  components: {
    SelfTestsList,
    FactoryTestList,
    SnapshotsList
  },
  props: ['profile'],

  data(){
    return {
      block: '',
    }
  },
  created() {
    if (this.$store.getters.getPermissions?.viewDeviceSelftestResults === true){
      this.block = 'SelfTestList'
    }else if (this.$store.getters.getPermissions?.viewDeviceSnapshot === true){
      this.block = 'SnapshotsList'
    }else if (this.$store.getters.getPermissions?.viewDeviceFactoryTest === true){
      this.block = 'FactoryTestList'
    }
  },
  methods: {
    selected_block(block){
      this.block = block
    },
  }
}
</script>

<style lang="scss" scoped>
.selftests{
  height: 100%;
  .tab{
    width: 100%;
    height: 5%;
    display: flex;
    align-content: center;
    justify-content: center;
    flex-direction: row;
    &_title{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      padding: 5px 0;
      cursor: pointer;
      font-weight: 600;
      font-size: 14px;
      text-align: center;
      background-color: #efe9e9;
      border: 1px solid #efe9e9;
      &.active{
        background-color: white;
        border-bottom: 1px solid white;
      }
    }
  }
  .block{
    height: 95%;
    border: 1px solid #efe9e9;
    margin-top: -1px;
    padding: 10px;
    overflow: auto;
    &::-webkit-scrollbar{
      width: 10px;
    }
  }
}
</style>
